import React, { Component } from 'react'
import { Formik, Form } from 'formik'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'
import UnauthorizedComponent from '../general/UnauthorizedComponent.jsx'

class ClienteFormularioComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            nombreCliente: '',
            comentarios: '',
            propietario: '',
            sociedades: [],
            allSociedades: [],
            loading: false,
            errors: {},
            socSearch: '',
            unauthorized: false,
        }
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("WRITE_CLIENTES")) {
            this.setState({ unauthorized: true })
            return
        }
        ElementsDataService.retrieveAllElements("sociedades")
            .then(r => this.setState({ allSociedades: r.data }))

        if (Number(this.props.match.params.id) === -1) return

        ElementsDataService.retrieveElement("clientes", this.state.id)
            .then(r => this.setState({
                nombreCliente: r.data.nombreCliente || '',
                comentarios: r.data.comentarios || '',
                propietario: r.data.propietario || '',
                sociedades: r.data.sociedades || [],
            }))
    }

    validate() {
        const errors = {}
        if (!this.state.nombreCliente) errors.nombreCliente = 'El nombre del proyecto es requerido'
        this.setState({ errors })
        return Object.keys(errors).length === 0
    }

    onSubmit() {
        if (!this.validate()) return
        this.setState({ loading: true })
        const cliente = {
            id: this.state.id,
            nombreCliente: this.state.nombreCliente,
            comentarios: this.state.comentarios,
            propietario: this.state.propietario,
            sociedades: this.state.sociedades,
        }
        if (Number(this.state.id) === -1) {
            ElementsDataService.createElement("clientes", cliente)
                .then(() => this.props.history.push('/clientes'))
        } else {
            ElementsDataService.updateElement("clientes", this.state.id, cliente)
                .then(() => this.props.history.push('/clientes'))
        }
    }

    set = (field) => (e) => this.setState({ [field]: e.target.value, errors: { ...this.state.errors, [field]: null } })

    render() {
        const { nombreCliente, comentarios, propietario, sociedades, allSociedades, loading, errors, socSearch } = this.state
        const isNew = Number(this.state.id) === -1

        const filteredSocs = allSociedades.filter(s =>
            !sociedades.find(x => x.rfc === s.rfc) &&
            (s.razonSocial + ' ' + s.rfc).toLowerCase().includes(socSearch.toLowerCase())
        )

        return (
            <div style={styles.root}>
                {this.state.unauthorized && <UnauthorizedComponent history={this.props.history} />}
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .clf-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .clf-input {
                        width: 100%; padding: 10px 14px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none;
                        transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .clf-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .clf-input.error { border-color: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,0.1); }
                    .clf-select {
                        width: 100%; padding: 10px 14px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none; cursor: pointer;
                        transition: all 0.2s; font-family: 'Inter', sans-serif; appearance: none;
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
                        background-repeat: no-repeat; background-position: right 12px center; padding-right: 36px;
                    }
                    .clf-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .clf-textarea {
                        width: 100%; padding: 10px 14px; min-height: 80px; resize: vertical;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none;
                        transition: all 0.2s; font-family: 'Inter', sans-serif; line-height: 1.6;
                    }
                    .clf-textarea:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .clf-label { font-size: 0.72rem; font-weight: 700; color: #64748b; letter-spacing: 0.8px; text-transform: uppercase; margin-bottom: 6px; display: block; }
                    .clf-error { font-size: 0.75rem; color: #ef4444; margin-top: 5px; }
                    .soc-item {
                        padding: 10px 14px; cursor: pointer; border-radius: 8px;
                        font-size: 0.82rem; color: #334155; transition: background 0.15s;
                        display: flex; flex-direction: column; gap: 2px;
                    }
                    .soc-item:hover { background: #eff6ff; }
                    .chip {
                        display: inline-flex; align-items: center; gap: 5px;
                        background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 20px;
                        padding: 4px 10px 4px 5px; font-size: 0.75rem; color: #2563eb; margin: 3px;
                    }
                    .chip button {
                        background: #bfdbfe; border: none; border-radius: 50%; width: 15px; height: 15px;
                        cursor: pointer; font-size: 0.6rem; color: #1d4ed8; padding: 0;
                        display: flex; align-items: center; justify-content: center;
                    }
                    .chip button:hover { background: #ef4444; color: white; }
                    .btn-save {
                        padding: 12px 32px; background: linear-gradient(135deg, #2563eb, #3b82f6);
                        border: none; border-radius: 10px; color: white; font-weight: 700;
                        font-size: 0.88rem; cursor: pointer; transition: all 0.2s;
                        font-family: 'Inter', sans-serif; box-shadow: 0 4px 14px rgba(59,130,246,0.35);
                    }
                    .btn-save:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(59,130,246,0.45); }
                    .btn-save:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
                    .btn-cancel {
                        padding: 12px 24px; background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; color: #64748b; font-weight: 600; font-size: 0.88rem;
                        cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .btn-cancel:hover { border-color: #94a3b8; color: #334155; }
                `}</style>

                <div className="clf-root" style={styles.inner}>

                    {/* Header */}
                    <div style={styles.header}>
                        <div>
                            <p style={styles.breadcrumb}>
                                <span style={{ cursor: 'pointer', color: '#3b82f6' }} onClick={() => this.props.history.push('/clientes')}>Proyectos</span>
                                <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                                <span>{isNew ? 'Nuevo Proyecto' : (nombreCliente || 'Editar')}</span>
                            </p>
                            <h1 style={styles.title}>{isNew ? 'Nuevo Proyecto' : (nombreCliente || 'Editar Proyecto')}</h1>
                        </div>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <button className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                            <button className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                {loading ? '⏳ Guardando...' : '✓ Guardar'}
                            </button>
                        </div>
                    </div>

                    <Formik initialValues={{}} onSubmit={this.onSubmit} enableReinitialize>
                        {() => (
                            <Form>
                                <div style={styles.sections}>

                                    {/* ── Datos del proyecto ── */}
                                    <div style={sectionStyle}>
                                        <div style={sectionHeader}>
                                            <span>📁</span>
                                            <h2 style={sectionTitle}>Datos del Proyecto</h2>
                                        </div>
                                        <div style={{ padding: '20px 24px' }}>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                                                <div>
                                                    <label className="clf-label">Nombre Proyecto *</label>
                                                    <input
                                                        className={`clf-input${errors.nombreCliente ? ' error' : ''}`}
                                                        value={nombreCliente}
                                                        onChange={e => this.setState({ nombreCliente: e.target.value.toUpperCase(), errors: { ...errors, nombreCliente: null } })}
                                                        placeholder="NOMBRE DEL PROYECTO"
                                                        autoComplete="off"
                                                    />
                                                    {errors.nombreCliente && <p className="clf-error">⚠ {errors.nombreCliente}</p>}
                                                </div>
                                                <div>
                                                    <label className="clf-label">Propietario</label>
                                                    <select className="clf-select" value={propietario} onChange={this.set('propietario')}>
                                                        <option value="">— Seleccionar —</option>
                                                        <option value="ST">ST</option>
                                                        <option value="SPH">SPH</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div>
                                                <label className="clf-label">Comentarios</label>
                                                <textarea
                                                    className="clf-textarea"
                                                    value={comentarios}
                                                    onChange={e => this.setState({ comentarios: e.target.value.toUpperCase() })}
                                                    placeholder="Notas o comentarios adicionales..."
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── Sociedades asociadas ── */}
                                    <div style={sectionStyle}>
                                        <div style={sectionHeader}>
                                            <span>🏢</span>
                                            <h2 style={sectionTitle}>Sociedades Asociadas</h2>
                                            {sociedades.length > 0 && (
                                                <span style={{ marginLeft: 'auto', fontSize: '0.75rem', background: '#eff6ff', color: '#3b82f6', border: '1px solid #bfdbfe', borderRadius: 20, padding: '2px 10px' }}>
                                                    {sociedades.length} seleccionada{sociedades.length !== 1 ? 's' : ''}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ padding: '20px 24px' }}>

                                            {/* Chips seleccionadas */}
                                            {sociedades.length > 0 && (
                                                <div style={{ marginBottom: 16, padding: 12, background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
                                                    {sociedades.map(s => (
                                                        <span key={s.rfc} className="chip">
                                                            <button type="button" onClick={() => this.setState({ sociedades: sociedades.filter(x => x.rfc !== s.rfc) })}>✕</button>
                                                            {s.razonSocial}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Buscador de sociedades */}
                                            <div style={{ marginBottom: 8 }}>
                                                <input
                                                    className="clf-input"
                                                    type="text"
                                                    placeholder="🔍 Buscar sociedad por nombre o RFC..."
                                                    value={socSearch}
                                                    onChange={e => this.setState({ socSearch: e.target.value })}
                                                />
                                            </div>

                                            {/* Lista */}
                                            {socSearch.length > 0 && (
                                                <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 10, background: 'white' }}>
                                                    {filteredSocs.length === 0 ? (
                                                        <div style={{ padding: '16px', textAlign: 'center', color: '#94a3b8', fontSize: '0.82rem' }}>
                                                            Sin resultados
                                                        </div>
                                                    ) : filteredSocs.slice(0, 50).map(s => (
                                                        <div key={s.rfc} className="soc-item" onClick={() => this.setState({ sociedades: [...sociedades, s], socSearch: '' })}>
                                                            <span style={{ fontWeight: 600 }}>{s.razonSocial}</span>
                                                            <span style={{ fontSize: '0.72rem', color: '#94a3b8', fontFamily: 'monospace' }}>{s.rfc}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {socSearch.length === 0 && sociedades.length === 0 && (
                                                <p style={{ margin: 0, fontSize: '0.82rem', color: '#94a3b8', textAlign: 'center', padding: '16px 0' }}>
                                                    Escribe en el buscador para agregar sociedades
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                </div>

                                {/* Footer */}
                                <div style={styles.footer}>
                                    <button type="button" className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                                    <button type="button" className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                        {loading ? '⏳ Guardando...' : '✓ Guardar Proyecto'}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        )
    }
}

const sectionStyle = { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, marginBottom: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }
const sectionHeader = { display: 'flex', alignItems: 'center', gap: 10, padding: '14px 24px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }
const sectionTitle = { margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }

const styles = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 780, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 },
    breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
    title: { margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, paddingTop: 4, marginBottom: 20 },
}

export default ClienteFormularioComponent
